import React from 'react'
import { SideBar } from '../styled'
import ProjectMenu from '../shared/ProjectMenu'
import * as Styled from './styled'
import { MainContentProps } from './types'

export const MainContent: React.FunctionComponent<MainContentProps> = ({ copy }) => (
  <Styled.Container>
    <SideBar>
      <ProjectMenu />
    </SideBar>
    <Styled.MainProjectsList copy={copy} />
  </Styled.Container>
)

export default MainContent
